import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { useCurrentUserContext } from '../../../../../../context/UserContext';



interface ConfirmMoveProps {
    actionCount: number
    targetTicketId: number;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmMove: React.FC<ConfirmMoveProps> = ({ actionCount, targetTicketId, onConfirm, onCancel }) => {
    const { profile } = useCurrentUserContext();
    return (
        <Dialog onClose={onCancel} title={'Confirm move?'} className='cool-window' width={300}>
            <p>
                Are you sure you want to move <strong>{actionCount}</strong> {profile?.Phrases.Action}s to {profile?.Phrases.CallPhrase} #<strong>{targetTicketId}</strong>? This action cannot be undone.
            </p>
            <DialogActionsBar>
                <Button svgIcon={svg.checkIcon} onClick={onConfirm} autoFocus style={{ color: '#fff', backgroundColor: profile?.Nav_Hex_Color }}>
                    Confirm
                </Button>
                <Button svgIcon={svg.cancelIcon} onClick={onCancel} fillMode='outline'>
                    Cancel
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
};

export default ConfirmMove;